<template>
  <div class="page-content" style="min-width:1205px;">
    <el-breadcrumb separator="/" class="breadcrumb">
        <el-breadcrumb-item :to="{ path: '/ServiceReport' }">智慧服务</el-breadcrumb-item>
        <el-breadcrumb-item>服务报告</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="min-height: 840px;margin-top: 40px;">
      <stepSecond ref='refStepSecond'></stepSecond>
    </div>
  </div>
</template>
<script>
import stepSecond from './createReportStep/step2';
import { mapGetters, mapActions, mapState } from "vuex";

export default {
	components:{stepSecond},
	data(){
			return{

			}
	},
	methods:{}
}
</script>
<style lang="scss">

</style>
